import React, { useCallback, useRef, useEffect, useState } from "react";
import { Box, DropdownBody, DropdownItem, Icons, useToast } from "fds";
import "./index.scss";
import {
  DocInfo,
  DocumentListReq,
  favoriteReq,
  FolderInfoDTO,
  MenuListType,
} from "../../types/files";
import utilsCommon from "../../shared/utils/common";
import ShareLinkModal from "../More/ShareLinkModal";
import ChangeFileNameModal from "../More/ChangeFileNameModal";
import ReadRequestModal from "../More/ReadRequestModal";
import { nanoid } from "@reduxjs/toolkit";
import ManaulRevisionCompleteModal from "../More/ManaulRevisionCompleteModal";
import WorkgroupAddModal from "../WorkgroupAddModal";
import LeaveCommentModal from "../More/LeaveCommentModal";
import FolderMoveModal from "../More/FolderMoveModal";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import ConfirmDeleteOrRestoreModal from "../More/ConfirmDeleteOrRestoreModal";
import ChangeFileAuthModal from "../More/ChangeFileAuthModal";
import docApi from "../../redux/api/DocApi";
import CreateNewFolderModal from "../../pages/Workgroup/WorkgroupFile/Modal/CreateNewFolderModal";
import DeleteFolderModal from "../../pages/Workgroup/WorkgroupFile/Modal/DeleteFolderModal";
import {
  handleDocPreview,
  doUnauthDocDownload,
  doDeleteDocument,
  handleDocDownload,
  handleSetContentFavorite,
} from "../../shared/utils/api";
import useStartDownload from "../../shared/hooks/useStartDownload";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { useTranslation } from "react-i18next";
import ChangeWorkgroupFileAuthModal from "../More/ChangeWorkgroupFileAuthModal";
import usePolicyStore from "../../redux/dispatcher/usePolicyStore";
import { useNavigate } from "react-router-dom";
interface DocSettingButtonProps {
  settingButtonInfo: {
    x: number;
    y: number;
    syncId: string;
    docInfo?: DocInfo;
    folderInfo?: FolderInfoDTO;
  };
  setDocSettingInfo: (req: {
    x: number;
    y: number;
    syncId: string;
    docInfo?: DocInfo;
    folderInfo?: FolderInfoDTO;
  }) => void;
  changeAsideInfo: (req: {
    syncId: string;
    workgroupId: string;
    contentName: string;
    revisionNo: number;
  }) => void;
  page?: string;
  filter?: DocumentListReq | favoriteReq;
  requiredRecallSyncId?: string[];
  asideInfo: {
    syncId: string;
    workgroupId: string;
    contentName: string;
    revisionNo: number;
  };
  changeRequiredRecallSyncIds?: (syncIds: string[]) => void;
  handleDeleteAfter: (syncIds: string[]) => void;
  changeFilterByKey?: (key: string, value: any) => void;
}
const DocSettingButton: React.FC<DocSettingButtonProps> = ({
  settingButtonInfo,
  page,
  filter,
  requiredRecallSyncId,
  asideInfo,
  changeRequiredRecallSyncIds,
  setDocSettingInfo,
  handleDeleteAfter,
  changeFilterByKey,
  changeAsideInfo,
}) => {
  const { t } = useTranslation();
  const gotoEditMode = async (
    workgroupId: string,
    syncId: string
  ): Promise<void> => {
    const newSyncInfo = await docApi.getDocSyncInfo({ workgroupId, syncId });

    if (
      newSyncInfo?.status === "N" &&
      newSyncInfo?.authType === "R" &&
      newSyncInfo?.checkoutUser.userId === ""
    ) {
      window.open(
        `/docs/preview?permission=edit&workgroupId=${workgroupId}&syncId=${syncId}&revisionNo=${newSyncInfo.revisionNo}&isClient=false`
      );
    } else {
      // await getSyncInfo({ workgroupId, syncId }); //TODO :  state setting

      if (newSyncInfo?.status === "T") {
        toast.toastMsg(nanoid(), t("file.alert.contentDelete"), "error");
      } else if (
        newSyncInfo?.authType === "V" ||
        newSyncInfo.authType !== "R"
      ) {
        toast.toastMsg(nanoid(), t("file.alert.checkoutFail"), "error");
      } else if (newSyncInfo?.checkoutUser.userId !== "") {
        toast.toastMsg(nanoid(), t("file.alert.checkoutAnotherUser"), "error");
      }
    }
    //권한 체크
  };

  const inputRef = useRef<HTMLTableRowElement>(null);
  const toast = useToast();
  const {
    getContentDownload,
    getDocDecryptDownload,
    getContentDetail,
    getDocDelete,
    getContentCheckout,
    getContentList,
    getContentUndoCheckout,
    forceCheckinByWeb,
    getContentFavorite,
  } = useDocumentStore();
  const { startDownload, resetStartDownload } = useStartDownload();
  const { updateStarItemFavorite } = useWorkgroupStore();
  const direction = document.documentElement.dir; // 'ltr' 또는 'rtl'
  const [height, setHeight] = useState(0);
  const [modalType, changeModalType] = useState("CLOSE");

  let menus = [
    {
      key: "preview",

      resource: utilsCommon.renderViewTooltip(
        settingButtonInfo.docInfo?.contentName ?? ""
      ),
      icon: <Icons variant="line" label="preview" isOn />,
      onClick: () =>
        settingButtonInfo.docInfo &&
        handleDocPreview({
          permission: "view",
          workgroupId: settingButtonInfo.docInfo?.workgroup.workgroupId,
          syncId: settingButtonInfo.docInfo?.syncId,
          toast,
          t,
          revisionNo: settingButtonInfo.docInfo?.revisionNo,
        }),
    },
    {
      key: "editMode",
      resource: utilsCommon.renderEditTooltip(
        settingButtonInfo.docInfo?.contentName ?? ""
      ),
      icon: <Icons variant="line" label="edit" isOn />,
      onClick: () =>
        settingButtonInfo.docInfo &&
        gotoEditMode(
          settingButtonInfo.docInfo?.workgroup.workgroupId,
          settingButtonInfo.docInfo?.syncId
        ),
    },
    {
      key: "shareLink",
      resource: t("file.action.shareLink"),
      icon: <Icons variant="line" label="link" />,
      onClick: () => changeModalType("SHARE_LINK"),
    },
    {
      key: "download",
      resource: t("file.action.download"),
      icon: <Icons variant="line" label="download" />,
      onClick: () =>
        handleDocDownload(
          settingButtonInfo.syncId,
          getContentDownload,
          toast,
          t
        ),
    },
    {
      key: "shareWorkgroup",
      resource: t("file.action.shareToOtherWorkgroup"),
      icon: <Icons variant="line" label="people" />,
      onClick: () => changeModalType("SHARE_FILE_TO_WORKGROUP"),
    },
    {
      key: "favorite",
      resource: t("file.action.removeFav"),
      icon: <Icons variant="line" label="star" isOn />,
      onClick: () =>
        handleSetContentFavorite({
          docInfos: settingButtonInfo.docInfo
            ? [settingButtonInfo.docInfo]
            : undefined,
          getContentFavorite: getContentFavorite,
          page: page,
          handleAfterSubmit: () => {
            setDocSettingInfo({
              x: 0,
              y: 0,
              syncId: "",
              docInfo: undefined,
            });
            updateStarItemFavorite({
              syncIds: [settingButtonInfo.docInfo?.syncId ?? ""],
              flag:
                !!settingButtonInfo.docInfo &&
                settingButtonInfo.docInfo?.favoritDate <= 0,
            });
          },
          flag:
            settingButtonInfo.docInfo &&
            settingButtonInfo.docInfo?.favoritDate <= 0,
        }),
    },
    {
      key: "notFavorite",
      resource: t("file.action.addFav"),
      icon: <Icons variant="fill" label="star" stroke="#F6C243" />,
      onClick: () =>
        handleSetContentFavorite({
          docInfos: settingButtonInfo.docInfo
            ? [settingButtonInfo.docInfo]
            : undefined,
          getContentFavorite: getContentFavorite,
          page: page,
          handleAfterSubmit: () => {
            setDocSettingInfo({
              x: 0,
              y: 0,
              syncId: "",
              docInfo: undefined,
            });
            updateStarItemFavorite({
              syncIds: [settingButtonInfo.docInfo?.syncId ?? ""],
              flag:
                !!settingButtonInfo.docInfo &&
                settingButtonInfo.docInfo?.favoritDate <= 0,
            });
          },
          flag:
            settingButtonInfo.docInfo &&
            settingButtonInfo.docInfo?.favoritDate <= 0,
        }),
    },
    {
      key: "checkout",
      resource: t("file.action.manualRevStart"),
      icon: <Icons variant="line" label="manualStart" />,
      onClick: () => handleDocCheckout(),
    },
    {
      key: "checkin",
      resource: t("file.action.manualRevComplete"),
      icon: <Icons variant="line" label="manualComplete" />,
      onClick: () => changeModalType("MANUAL_REVISION_COMPLETE"),
    },
    {
      key: "undoCheckout",
      resource: t("file.action.manualRevCancel"),
      icon: <Icons variant="line" label="manualCancel" />,
      onClick: () => handleDocCheckCancel(),
    },
    {
      key: "forceCheckin",
      resource: t("file.action.forceRevComplete"),
      icon: <Icons variant="line" label="editExit" />,
      onClick: () => handleDocForceComplete(),
    },
    {
      key: "auth",
      resource: t("file.action.auth"),
      icon: <Icons variant="line" label="access" />,
      onClick: () =>
        settingButtonInfo.docInfo?.workgroup.workgroupId === "NONEWORKGROUP"
          ? changeModalType("CHANGE_FILE_AUTH")
          : changeModalType("CHANGE_FILE_AUTH_WORKGROUP"),
    },
    {
      key: "requestOpen",
      resource: t("file.action.sendReadRequest"),
      icon: <Icons variant="line" label="alertOctagon" />,
      onClick: () => changeModalType("READ_REQUEST"),
    },
    {
      key: "leaveComment",
      resource: t("file.action.leaveComment"),
      icon: <Icons variant="line" label="memo" />,
      onClick: () => changeModalType("LEAVE_MEMO"),
    },
    {
      key: "unAuthDownload",
      resource: t("file.action.decryptedDownload"),
      icon: <Icons variant="line" label="unlock" />,
      onClick: () => {
        if (!settingButtonInfo.docInfo) return;
        doUnauthDocDownload(
          settingButtonInfo.docInfo,
          toast,
          getDocDecryptDownload,
          startDownload
        );
        handleTurnOffSettng();
      },
    },
    {
      key: "changeName",
      resource: t("file.action.rename"),
      icon: <Icons variant="line" label="edit2" />,
      onClick: () => changeModalType("CHANGE_FILE_NAME"),
    },
    {
      key: "restore",
      resource: t("trash.action.restore"),
      icon: <Icons variant="line" label="redoLeft" />,
      onClick: () => changeModalType("RESTORE_FILE"),
    },
    {
      key: "adminTrash",
      resource: t("common.delete"),
      icon: <Icons variant="line" label="delete" />,
      onClick: () => changeModalType("DELETE_PERM"),
    },
    {
      key: "deletePerm",
      resource: t("trash.action.permDelete"),
      icon: <Icons variant="line" label="delete" />,
      onClick: () => changeModalType("DELETE_PERM"),
    },
    {
      key: "changeFolderName",
      resource: t("file.action.rename"),
      icon: <Icons variant="line" label="edit2" />,
      onClick: () => changeModalType("CHANGE_FOLDER_NAME"),
    },

    {
      key: "folderMove",
      resource: t("common.move"),
      icon: <Icons variant="line" label="foldermove" />,
      onClick: () => changeModalType("FOLDER_MOVE"),
    },
    // { key: "googleUpload" },
  ] as {
    key: MenuListType;
    resource: string;
    icon: React.ReactNode;
    onClick?: () => void;
  }[];

  useEffect(() => {
    if (
      requiredRecallSyncId?.includes(settingButtonInfo.syncId) &&
      changeRequiredRecallSyncIds
    ) {
      changeRequiredRecallSyncIds(
        requiredRecallSyncId?.filter(
          (item) => item !== settingButtonInfo.syncId
        ) ?? []
      );
      getContentDetail({
        workgroupId:
          settingButtonInfo.docInfo?.workgroup?.workgroupId ?? "NONEWORKGORUP",
        syncId: settingButtonInfo.syncId,
      }).then((resp: any) => {
        setDocSettingInfo({
          ...settingButtonInfo,
          docInfo: resp.payload.documentInfo,
        });
      });
    }
  }, [requiredRecallSyncId]);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  useEffect(() => {
    if (!inputRef.current) return;
    const observer = new ResizeObserver(() => {
      if (inputRef.current) {
        setHeight(inputRef.current.offsetHeight);
      }
    });
    observer.observe(inputRef.current);
    return () => observer.disconnect();
  }, []);
  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (inputRef.current && !(inputRef.current! as any).contains(e.target)) {
      handleTurnOffSettng();
      document.removeEventListener("click", handleClickOutside, true);
    }
  }, []);
  const handleTurnOffSettng = (): void => {
    setDocSettingInfo({
      x: 0,
      y: 0,
      syncId: "",
      docInfo: undefined,
    });
    changeModalType("CLOSE");
  };
  /** 수동 리비전 시작 */
  const handleDocCheckout = async () => {
    if (!settingButtonInfo.docInfo) return;
    let resp: any = await getContentCheckout({
      workgroupId: settingButtonInfo.docInfo?.workgroup.workgroupId,
      syncId: settingButtonInfo.docInfo?.syncId,
      revisionNo: settingButtonInfo.docInfo.revisionNo,
    });
    if (resp.payload) {
      await getContentDownload({
        syncId: settingButtonInfo.docInfo?.syncId,
        revisionNo: settingButtonInfo.docInfo.revisionNo + "",
        startDownload: startDownload,
        resetStartDownload: resetStartDownload,
      });
      toast.toastMsg(nanoid(), t("file.manualRev.alert.start"), "success");
      if (filter && typeof filter === "object" && "folderCode" in filter) {
        getContentList(filter as DocumentListReq);
      }
    } else if (resp.error?.message) {
      toast.toastMsg(nanoid(), resp.error.message, "error");
    }
    handleTurnOffSettng();
  };
  /** 수동 리비전 취소 */
  const handleDocCheckCancel = async () => {
    if (!settingButtonInfo.docInfo) return;
    let resp: any = await getContentUndoCheckout({
      workgroupId: settingButtonInfo.docInfo?.workgroup.workgroupId,
      syncId: settingButtonInfo.docInfo?.syncId,
      revisionNo: settingButtonInfo.docInfo.revisionNo,
    });
    if (resp.payload) {
      toast.toastMsg(
        nanoid(),
        t("file.manualRev.alert.cancelSuccess"),
        "success"
      );
      if (filter && typeof filter === "object" && "folderCode" in filter) {
        getContentList(filter as DocumentListReq);
      }
    } else {
      toast.toastMsg(
        nanoid(),
        resp.error.message ?? t("file.manualRev.alert.cancelFail"),
        "error"
      );
    }
    handleTurnOffSettng();
  };
  /** 수동 리비전 강제 완료 */
  const handleDocForceComplete = async () => {
    if (!settingButtonInfo.docInfo) return;
    let resp: any = await forceCheckinByWeb(settingButtonInfo.docInfo?.syncId);
    if (resp.payload) {
      toast.toastMsg(nanoid(), t("file.alert.forceDeleteSuccess"), "success");
      if (filter && typeof filter === "object" && "folderCode" in filter) {
        getContentList(filter as DocumentListReq);
      }
    } else {
      toast.toastMsg(
        nanoid(),
        resp.error.message ?? t("file.alert.forceDeleteFail"),
        "error"
      );
    }
    handleTurnOffSettng();
  };
  return (
    <>
      {modalType === "CLOSE" ? (
        <DropdownBody
          maxWidth={
            page === "trash" ? undefined : window.eco.isCspp ? 340 : 300
          }
          dropdownRef={inputRef}
          minWidth={190}
          width={"fit-content"}
          maxHeight={window.innerHeight - 120}
          location={{
            x:
              settingButtonInfo.x -
              (direction === "ltr" &&
              settingButtonInfo.x > window.innerWidth / 2
                ? window.eco.isCspp
                  ? inputRef.current?.getBoundingClientRect().width ?? 210
                  : 210
                : 0) -
              (window.eco.serviceType === "OCI" ? 55 : 0) -
              (direction === "ltr"
                ? (document
                    .getElementById("sidemenuId")
                    ?.getBoundingClientRect().width ?? 240) - 245
                : 0) -
              (direction === "rtl" &&
              window.eco.companyName === "linkApp" &&
              !utilsCommon.isDemoEco()
                ? 38
                : 0),
            y:
              settingButtonInfo.y -
              (settingButtonInfo.y > window.innerHeight / 2 ? height : 0),
          }}
        >
          <Box
            direction={"column"}
            maxHeight={
              utilsCommon.checkMenuAvailble(
                "delete",
                settingButtonInfo.docInfo ?? settingButtonInfo.folderInfo,
                page
              )
                ? 296
                : 342
            }
            classes="overflow-scroll"
          >
            {menus
              .filter((item) =>
                utilsCommon.checkMenuAvailble(
                  item.key,
                  settingButtonInfo.docInfo ?? settingButtonInfo.folderInfo,
                  page
                )
              )
              .map((item) => (
                <DropdownItem
                  height={item.key === "divider" ? undefined : 20}
                  type={
                    item.key.includes("delete")
                      ? "warning"
                      : item.key === "checkin"
                      ? "green"
                      : "default"
                  }
                  state={item.key === "divider" ? "divider" : "default"}
                  label={item.resource}
                  frontIcon={item.icon}
                  onClick={item.onClick}
                />
              ))}
          </Box>
          {[
            {
              key: "divider",
            },
            {
              key: "folderdelete",
              resource: t("file.action.deleteFolder"),
              icon: <Icons variant="line" label="delete" />,
              onClick: () => changeModalType("FOLDER_DELETE"),
            },
            {
              key: "delete",
              resource: t("common.delete"),
              icon: <Icons variant="line" label="delete" />,
              onClick: () =>
                !!settingButtonInfo?.docInfo?.syncId &&
                doDeleteDocument(
                  [settingButtonInfo?.docInfo],
                  toast,
                  getDocDelete,
                  () => {
                    handleDeleteAfter &&
                      handleDeleteAfter(
                        settingButtonInfo?.docInfo?.syncId
                          ? [settingButtonInfo?.docInfo?.syncId]
                          : []
                      );
                    handleTurnOffSettng();
                  }
                ),
            },
          ]
            .filter((item) =>
              utilsCommon.checkMenuAvailble(
                item.key,
                settingButtonInfo.docInfo ?? settingButtonInfo.folderInfo,
                page
              )
            )
            .map((item) => (
              <DropdownItem
                height={item.key === "divider" ? undefined : 20}
                type={item.key.includes("delete") ? "warning" : "default"}
                state={item.key === "divider" ? "divider" : "default"}
                label={item.resource}
                frontIcon={item.icon}
                onClick={item.onClick}
              />
            ))}
        </DropdownBody>
      ) : (
        <>
          {modalType === "SHARE_LINK" && (
            <ShareLinkModal
              open={modalType === "SHARE_LINK"}
              onClose={handleTurnOffSettng}
              docInfo={settingButtonInfo.docInfo}
            />
          )}
          {modalType === "CHANGE_FILE_NAME" && (
            <ChangeFileNameModal
              open={modalType === "CHANGE_FILE_NAME"}
              onClose={handleTurnOffSettng}
              docInfo={settingButtonInfo.docInfo}
            />
          )}
          {modalType === "READ_REQUEST" && (
            <ReadRequestModal
              open={modalType === "READ_REQUEST"}
              onClose={handleTurnOffSettng}
              docInfo={settingButtonInfo.docInfo}
            />
          )}
          {modalType === "MANUAL_REVISION_COMPLETE" && (
            <ManaulRevisionCompleteModal
              open={modalType === "MANUAL_REVISION_COMPLETE"}
              onClose={handleTurnOffSettng}
              docInfo={settingButtonInfo.docInfo}
            />
          )}
          {modalType === "LEAVE_MEMO" && (
            <LeaveCommentModal
              open={true}
              onClose={handleTurnOffSettng}
              docInfo={settingButtonInfo.docInfo}
            />
          )}
          {modalType === "FOLDER_MOVE" && settingButtonInfo.docInfo && (
            <FolderMoveModal
              open={true}
              onClose={handleTurnOffSettng}
              docInfo={[settingButtonInfo.docInfo]}
            />
          )}
          {modalType === "CHANGE_FOLDER_NAME" && (
            <CreateNewFolderModal
              open={true}
              workgroupId={settingButtonInfo.folderInfo?.workgroupId}
              targetFolderId={settingButtonInfo.folderInfo?.folderId}
              initFolderName={settingButtonInfo.folderInfo?.folderName}
              onClose={handleTurnOffSettng}
            />
          )}
          {modalType === "FOLDER_DELETE" && (
            <DeleteFolderModal
              open={true}
              targetFolderId={settingButtonInfo.folderInfo?.folderId}
              folderName={settingButtonInfo.folderInfo?.folderName}
              onClose={handleTurnOffSettng}
            />
          )}
          {modalType === "SHARE_FILE_TO_WORKGROUP" &&
            settingButtonInfo.docInfo && (
              <WorkgroupAddModal
                open={modalType === "SHARE_FILE_TO_WORKGROUP"}
                onClose={handleTurnOffSettng}
                uploadedFiles={[settingButtonInfo.docInfo]}
                createType={"SHARE_TO_WORKGROUP"}
              />
            )}
          {modalType === "RESTORE_FILE" && (
            <ConfirmDeleteOrRestoreModal
              open={modalType === "RESTORE_FILE"}
              onClose={handleTurnOffSettng}
              type="restore"
              syncIds={[settingButtonInfo.syncId]}
              onClickAfter={() => {
                if (settingButtonInfo.syncId === asideInfo.syncId)
                  changeAsideInfo({
                    syncId: "",
                    workgroupId: "",
                    contentName: "",
                    revisionNo: -1,
                  });
              }}
            />
          )}
          {modalType === "CHANGE_FILE_AUTH" && (
            <ChangeFileAuthModal
              open={modalType === "CHANGE_FILE_AUTH"}
              onClose={handleTurnOffSettng}
              docInfo={settingButtonInfo.docInfo}
            />
          )}
          {modalType === "CHANGE_FILE_AUTH_WORKGROUP" &&
            settingButtonInfo.docInfo && (
              <ChangeWorkgroupFileAuthModal
                open={modalType === "CHANGE_FILE_AUTH_WORKGROUP"}
                onClose={handleTurnOffSettng}
                docInfos={[settingButtonInfo.docInfo]}
              />
            )}
          {modalType === "DELETE_PERM" && (
            <ConfirmDeleteOrRestoreModal
              open={modalType === "DELETE_PERM"}
              onClose={handleTurnOffSettng}
              type={page?.includes("manageStorage") ? "adminDelete" : "delete"}
              syncIds={[settingButtonInfo.syncId]}
              onClickAfter={() => {
                page?.includes("manageStorage") &&
                  changeFilterByKey &&
                  changeFilterByKey("refresh", 0);
              }}
            />
          )}
        </>
      )}
    </>
  );
};
export default DocSettingButton;
